import { render, staticRenderFns } from "./courseunitinfoadd.vue?vue&type=template&id=c04b332a&scoped=true"
import script from "./courseunitinfoadd.vue?vue&type=script&lang=js"
export * from "./courseunitinfoadd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04b332a",
  null
  
)

export default component.exports